import request from '@/utils/request'


// 查询汽车门店列表
export function listCarShop(query) {
  return request({
    url: '/carShop/carShop/list',
    method: 'get',
    params: query
  })
}

// 查询汽车门店分页
export function pageCarShop(query) {
  return request({
    url: '/carShop/carShop/page',
    method: 'get',
    params: query
  })
}

// 查询汽车门店详细
export function getCarShop(data) {
  return request({
    url: '/carShop/carShop/detail',
    method: 'get',
    params: data
  })
}

// 新增汽车门店
export function addCarShop(data) {
  return request({
    url: '/carShop/carShop/add',
    method: 'post',
    data: data
  })
}

// 修改汽车门店
export function updateCarShop(data) {
  return request({
    url: '/carShop/carShop/edit',
    method: 'post',
    data: data
  })
}

// 删除汽车门店
export function delCarShop(data) {
  return request({
    url: '/carShop/carShop/delete',
    method: 'post',
    data: data
  })
}
